import { createActionCreator } from 'deox';

export const signInActions = {
  request: createActionCreator('SIGN_IN_REQUEST', (resolve) => (email: string, password: string) =>
    resolve({ email, password }),
  ),
  success: createActionCreator('SIGN_IN_SUCCESS'),
  failure: createActionCreator('SIGN_IN_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const signInWithOAuthActions = {
  request: createActionCreator('SIGN_IN_WITH_OAUTH_REQUEST', (resolve) => (authData) =>
    resolve({ authData }),
  ),
  success: createActionCreator('SIGN_IN_WITH_OAUTH_SUCCESS'),
  failure: createActionCreator('SIGN_IN_WITH_OAUTH_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const forgotPasswordActions = {
  request: createActionCreator('FORGOT_PASSWORD_REQUEST', (resolve) => (identifier: string) =>
    resolve({ identifier }),
  ),
  success: createActionCreator('FORGOT_PASSWORD_SUCCESS'),
  failure: createActionCreator('FORGOT_PASSWORD_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const resetPasswordActions = {
  request: createActionCreator(
    'RESET_PASSWORD_REQUEST',
    (resolve) => (code: string, password: string) => resolve({ code, password }),
  ),
  success: createActionCreator('RESET_PASSWORD_SUCCESS'),
  failure: createActionCreator('RESET_PASSWORD_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const registerUserWithEmailActions = {
  request: createActionCreator(
    'REGISTER_USER_WITH_EMAIL_REQUEST',
    (resolve) => (email: string, firstName: string, lastName: string, password: string) =>
      resolve({ email, firstName, lastName, password }),
  ),
  success: createActionCreator('REGISTER_USER_WITH_EMAIL_SUCCESS'),
  failure: createActionCreator('REGISTER_USER_WITH_EMAIL_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const registerUserWithInviteCodeActions = {
  request: createActionCreator(
    'REGISTER_USER_WITH_INVITE_CODE_REQUEST',
    (resolve) => (inviteCode: string, firstName: string, lastName: string, password: string) =>
      resolve({ inviteCode, firstName, lastName, password }),
  ),
  success: createActionCreator('REGISTER_USER_WITH_INVITE_CODE_SUCCESS'),
  failure: createActionCreator(
    'REGISTER_USER_WITH_INVITE_CODE_FAILURE',
    (resolve) => (error: unknown) => resolve({ error }),
  ),
};

export const logoutUserActions = {
  request: createActionCreator('LOGOUT_USER_REQUEST'),
  success: createActionCreator('LOGOUT_USER_SUCCESS'),
  failure: createActionCreator('LOGOUT_USER_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const activateAccountActions = {
  request: createActionCreator(
    'ACTIVATE_ACCOUNT_REQUEST',
    (resolve) => (activateToken: string, code: string) => resolve({ activateToken, code }),
  ),
  success: createActionCreator('ACTIVATE_ACCOUNT_SUCCESS'),
  failure: createActionCreator('ACTIVATE_ACCOUNT_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};
